<template>
  <div class="statistik">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col">
                <h3 class="page-title">Post Statistik</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Post Statistik</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Page Header -->
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="of-card-body-a">
                    <div v-if="caption" class="of-card-body-cap">
                      <div class="of-card-body-cap-1">
                        <p :title="caption" class="of-card-body-cap-2">
                          {{ caption }}
                        </p>
                      </div>
                    </div>
                    <div class="of-card-body-img">
                      <template v-if="assetsUrl.length > 0">
                        <img
                          v-if="
                            assetsUrl[0].includes('.jpg') ||
                              assetsUrl[0].includes('.jpeg')
                          "
                          class="of-card-body-img-p"
                          :src="assetsUrl[0]"
                          :alt="caption"
                        />
                        <video
                          style="width: 100%; height: 100%; overflow: hidden;"
                          v-else-if="assetsUrl[0].includes('.mp4')"
                          controls
                        >
                          <source :src="assetsUrl[0]" type="video/mp4" />
                        </video>
                        <img
                          v-else
                          class="of-card-body-img-p"
                          :src="require('@/assets/placeholder.jpg')"
                          alt=""
                        />
                      </template>
                      <template v-else>
                        <img
                          class="of-card-body-img-p"
                          :src="require('@/assets/placeholder.jpg')"
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                  <div class="of-card-body-b"></div>
                </div>
              </div>

              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-striped custom-table mb-0">
                      <thead>
                        <tr>
                          <th>Accounts</th>
                          <th>Total Like</th>
                          <th>Total Play</th>
                          <th>Total Comments</th>
                          <th>Total Impressions</th>
                          <th>Total Reach</th>
                          <th>Total Interactions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="loading">
                          <tr>
                            <td colspan="7">
                              <Skeleton :count="1" />
                            </td>
                          </tr>
                        </template>
                        <template v-if="rows.length">
                          <tr v-for="(row, index) in rows" :key="index">
                            <td class="text-wrap" :ref="'account-' + row.id">
                              <Skeleton :count="1" />
                            </td>
                            <td class="text-wrap">{{ row.total_like }}</td>
                            <td class="text-wrap">{{ row.total_play }}</td>
                            <td class="text-wrap">{{ row.total_comment }}</td>
                            <td class="text-wrap">
                              {{ row.total_impressions }}
                            </td>
                            <td class="text-wrap">{{ row.total_reach }}</td>
                            <td class="text-wrap">
                              {{ row.total_interactions }}
                            </td>
                          </tr>
                        </template>
                        <template v-else-if="rows.length < 1 && !loading">
                          <tr>
                            <td colspan="7" class="text-center">-empty-</td>
                          </tr>
                        </template>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td><b>Summary</b></td>
                          <td v-for="(rowSum, idx) in summary" :key="idx">
                            {{ rowSum.total }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Page Content -->
      </div>
      <!-- Page Wrapper -->
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

export default {
  name: "PostStatistik",
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      serverParams: {
        instagram_schedule_id: ""
      },
      summary: [],
      rows: [],
      assetsUrl: [],
      caption: "",
      media_type: "",
      loading: false
    };
  },
  created() {
    this.serverParams.instagram_schedule_id = this.$route.query.instagram_schedule_id;
    this.getDetailLog();
  },
  methods: {
    getDetailLog() {
      this.loading = true;

      this.$store
        .dispatch("instagramSchedule/getDetailLog", this.serverParams)
        .then(response => {
          const { data } = response;
          this.summary = data.summary;
          this.rows = data.data;
          this.assetsUrl = this.rows[0].assets_url
            ? JSON.parse(this.rows[0].assets_url)
            : [];
          this.caption = this.rows[0].caption ? this.rows[0].caption : "";
          this.media_type = this.rows[0].media_type
            ? this.rows[0].media_type
            : "";

          this.rows.forEach(row => {
            if (
              row.instagram_account_id != "" &&
              row.instagram_account_id != null
            ) {
              this.$store
                .dispatch("instagramAccount/detail", row.instagram_account_id) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["account-" + row.id][0].innerHTML =
                    " <a href='https://www.instagram.com/" +
                    resData.username +
                    "/' target='_blank'>" +
                    resData.username +
                    "</a>";
                });
            }
          });

          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  }
};
</script>

<style scoped>
.flex-center {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.of-card-body-a {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.of-card-body-cap {
  margin-bottom: 12px;
  border: 1px solid rgb(222, 225, 225);
  border-radius: 8px;
  padding: 8px 10px;
  width: 100%;
  max-width: 299px;
}
.of-card-body-cap-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
}
.of-card-body-cap-2 {
  font-size: 13px;
  line-height: 21.3333px;
  color: #364141;
}
.of-card-body-img {
  border: 1px solid rgb(222, 225, 225);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-width: 299px;
}
.of-card-body-img-p {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  max-width: 100%;
}
.of-card-body-b {
  padding-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/instagram/instagramScheduleOfficial/statistik.vue